import { AUDIT_BASE_URL } from "../../utils/ApiUrls"; 

class AuditUserManagementService {
    // Get users with their roles (with optional search)
    async getUserRoles(accessToken, pagination_data = {}, searchTerm = '') {
        // Build query parameters
        const queryParams = new URLSearchParams();
        
        try {
            if (pagination_data.page) {
                queryParams.append('page', pagination_data.page);
            }
            if (pagination_data.page_size) {
                queryParams.append('page_size', pagination_data.page_size);
            }
            if (searchTerm && searchTerm.trim()) {
                queryParams.append('search', searchTerm.trim());
            }

            const queryString = queryParams.toString();
            const response = await fetch(`${AUDIT_BASE_URL}/users/list${queryString ? `?${queryString}` : ''}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`,
                },
            });

            const data = await response.json();

            if (!response.ok) {
                return {
                    success: false,
                    status: response.status,
                    error: data.detail || 'Error fetching user roles',
                    errorData: data,
                };
            }

            return {
                success: true,
                status: response.status,
                data: data,
            };
        } catch (error) {
            return {
                success: false,
                status: 0,
                error: error.message || 'Network error occurred',
                errorData: null,
            };
        }
    }

    // Get available audit roles
    async getAvailableRoles(accessToken) {
        try {
            const response = await fetch(`${AUDIT_BASE_URL}/users/audit-roles`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`,
                },
            });

            const data = await response.json();

            if (!response.ok) {
                return {
                    success: false,
                    status: response.status,
                    error: data.detail || 'Error fetching available roles',
                    errorData: data,
                };
            }

            return {
                success: true,
                status: response.status,
                data: data,
            };
        } catch (error) {
            return {
                success: false,
                status: 0,
                error: error.message || 'Network error occurred',
                errorData: null,
            };
        }
    }

    // Assign roles to user
    async assignRolesToUser(userId, roleIds, accessToken) {
        try {
            const response = await fetch(`${AUDIT_BASE_URL}/users/assign-roles`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`,
                },
                body: JSON.stringify({
                    user_id: userId,
                    role_ids: roleIds
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                return {
                    success: false,
                    status: response.status,
                    error: data.detail || 'Error assigning roles',
                    errorData: data,
                };
            }

            return {
                success: true,
                status: response.status,
                data: data,
            };
        } catch (error) {
            return {
                success: false,
                status: 0,
                error: error.message || 'Network error occurred',
                errorData: null,
            };
        }
    }

    // Remove role from user
    async removeRoleFromUser(userId, roleId, accessToken) {
        try {
            const response = await fetch(`${AUDIT_BASE_URL}/users/remove-role`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`,
                },
                body: JSON.stringify({
                    user_id: userId,
                    role_id: roleId
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                return {
                    success: false,
                    status: response.status,
                    error: data.detail || 'Error removing role',
                    errorData: data,
                };
            }

            return {
                success: true,
                status: response.status,
                data: data,
            };
        } catch (error) {
            return {
                success: false,
                status: 0,
                error: error.message || 'Network error occurred',
                errorData: null,
            };
        }
    }



    async filterAuditUserSearch(accessToken, searchTerm = '') {
        try {
          const response = await fetch(`${AUDIT_BASE_URL}/users/search-audit-users/?q=${searchTerm}`, {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${accessToken}` // if your API is protected
            }
          });
          const data = await response.json();
    
          if (!response.ok) {
            return {
              success: false,
              status: response.status,
              error: data.detail || 'Error searching audit users',
              errorData: data,
            };
          }
    
          return {
            success: true,
            status: response.status,
            data: data,
          };
        } catch (error) {
          return {
            success: false,
            status: 0,
            error: error.message || 'Network error occurred',
            errorData: null,
          };
        }
    }
}

// Export a single instance
const auditUserManagementService = new AuditUserManagementService();
export default auditUserManagementService;


